import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  Snackbar,
  InputAdornment,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { useAppStore } from "../../../../appStore";
import { api_url } from "../../../../apiUtils";
import TransferSuccessDialog from "./successDilaog";
import { toast } from "react-toastify";
import CheckIcon from "@mui/icons-material/Check";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function GroupTransferSimple() {
  const [recipientMobile, setRecipientMobile] = useState("");
  const [reEnteredRecipientMobile, setReEnteredRecipientMobile] = useState("");
  const [amount, setAmount] = useState("");
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [otpSent, setOtpSent] = useState(false);
  const [otpId, setOtpId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mobileError, setMobileError] = useState("");
  const [isValidMobile, setIsValidMobile] = useState(false);

  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [amountError, setAmountError] = useState("");
  const otpFee = 10; // Or fetch dynamically if needed

  const handleAmountChange = (e) => {
    const val = e.target.value;
    if (validateAmount(val)) {
      const numVal = Number(val);
      if (!val) {
        setAmount("");
        setAmountError("");
      } else if (walletBalance < numVal + otpFee) {
        setAmount(val);
        setAmountError(
          "Wallet balance is too low for this transfer + transaction fee + OTP charge ."
        );
      } else {
        setAmount(val);
        setAmountError("");
      }
    }
  };

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const { profileDetails, setWalletBalance, walletBalance } = useAppStore();
  const senderMobile = profileDetails?.primaryPhone?.contactValue;
  // const senderMobile = 8073135867;

  const inputRefs = useRef([]);

  const handleCloseSnackbar = () => {
    setSnackbar({ open: false, message: "", severity: "success" });
  };

  const validateMobileNumber = (value) => /^[0-9]{0,10}$/.test(value);
  const validateAmount = (value) => /^[0-9]*$/.test(value);

  const checkMobileExists = async (number) => {
    if (number === senderMobile) {
      setMobileError("You cannot request points to your own number.");
      setIsValidMobile(false);
      return;
    }

    try {
      await axios.get(`${api_url}wallet/check-mobilenumber/${number}`);
      setMobileError("");
      setIsValidMobile(true);
    } catch (error) {
      const msg = error.response?.data?.message || "Validation failed.";
      setMobileError(msg);
      setIsValidMobile(false);
    }
  };

  useEffect(() => {
    if (recipientMobile.length === 10) {
      checkMobileExists(recipientMobile);
    } else {
      setMobileError("");
      setIsValidMobile(false);
    }
  }, [recipientMobile]);

  const getWalletPoints = async () => {
    const response = await axios.get(`${api_url}wallet/balance`, {
      headers: { accesstoken: sessionStorage.getItem("accesstoken") },
    });
    const request = response.data;
    setWalletBalance(request?.walletPoint?.balance);
    return response.data;
  };

  const handleGroupTransfer = async () => {
    if (!recipientMobile || !reEnteredRecipientMobile || !amount) {
      toast.error("All fields are required.");
      return;
    }

    if (recipientMobile !== reEnteredRecipientMobile) {
      toast.error("Recipient numbers do not match.");
      return;
    }

    if (!isValidMobile) {
      toast.error("Please enter a valid recipient number.");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${api_url}wallet/group-transfer`,
        {
          senderMobile,
          recipientMobile,
          amount,
        },
        {
          headers: {
            accesstoken: sessionStorage.getItem("accesstoken"),
          },
        }
      );

      toast.success("Group transfer successful!");
      setSuccessDialogOpen(true);
      setRecipientMobile("");
      setReEnteredRecipientMobile("");
      setAmount("");
      getWalletPoints(); // Refresh wallet balance
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || "Group transfer failed. Try again.";
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getWalletPoints();
  }, [amount]);

  return (
    <Box maxWidth={900} sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ mb: 2, color: "#161b4d" }}>
        Group Transfer [ Hand To Hand ]
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                From
              </Typography>
              <TextField
                size="small"
                fullWidth
                value={senderMobile}
                placeholder="Sender Mobile Number"
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 10 }}
                required
                disabled
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <div
                        style={{
                          borderRight: "1px solid #ccc",
                          color: "#bdbdbd",
                          padding: 2,
                        }}
                      >
                        +91
                      </div>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                To Mobile Number <span style={{ color: "red" }}>*</span>
              </Typography>
              <Typography variant="caption" sx={{ mb: 1, display: "block" }}>
                SMINDIA2050 Registered Mobile Number
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={recipientMobile}
                onChange={(e) => {
                  const val = e.target.value;
                  if (validateMobileNumber(val)) setRecipientMobile(val);
                }}
                placeholder="Enter 10-digit number"
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 10 }}
                error={!!mobileError}
                helperText={mobileError}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <div
                        style={{
                          borderRight: "1px solid #ccc",
                          padding: 2,
                          color: "#bdbdbd",
                        }}
                      >
                        +91
                      </div>
                    </InputAdornment>
                  ),
                  endAdornment: isValidMobile && (
                    <InputAdornment position="end">
                      <CheckIcon style={{ color: "green" }} />
                    </InputAdornment>
                  ),
                }}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                Re-Enter To Mobile Number{" "}
                <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={reEnteredRecipientMobile}
                onChange={(e) => {
                  const val = e.target.value;
                  if (validateMobileNumber(val))
                    setReEnteredRecipientMobile(val);
                }}
                placeholder="Re-enter 10-digit number"
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 10 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <div
                        style={{
                          borderRight: "1px solid #ccc",
                          padding: 2,
                          color: "#bdbdbd",
                        }}
                      >
                        +91
                      </div>
                    </InputAdornment>
                  ),
                }}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                Transfer Points <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                fullWidth
                size="small"
                type="tel"
                inputProps={{
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
                value={amount}
                onChange={handleAmountChange}
                placeholder="Enter Points"
                required
                error={!!amountError}
                helperText={amountError}
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                onClick={handleGroupTransfer}
                disabled={loading || !!amountError || !amount}
                sx={{ background: "#161b4d" }}
              >
                {loading ? "Processing..." : "Submit"}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <TransferSuccessDialog
        open={successDialogOpen}
        onClose={() => setSuccessDialogOpen(false)}
      />
    </Box>
  );
}

export default GroupTransferSimple;
